import { ReactNode, useState } from "react";
import { ModalProvider, ModalTrigger } from "../../../../Modal/Modal";
import HandlingerDropdownTrigger from "../../../../Table/HandlingerDropdownTrigger";
import {
  DropdownContent,
  DropdownItem,
  DropdownItemIcon,
  DropdownRoot,
  DropdownSeparator,
} from "../../../../dropdown/Dropdown";
import EmailIcon from "../../../../icons/EmailIcon";
import DownloadListIcon from "../../../../icons/DownloadListIcon";
import SendEmailModal from "../../../../sendEmail/SendEmailModal";

export interface KursusDeltagereHandlingerDropdownProps {
  type: IEmailTypes;
  typeTitle: string;
  selectedIds: string[];
  allSelected: boolean;
  totalCount: number;
  emailAbleIds: string[];
  typeId?: string;
  badgeSolid?: boolean;
  onDownloadToExcel?: () => void;
  children?: ReactNode;
}

const KursusDeltagereHandlingerDropdown = ({
  typeTitle,
  selectedIds,
  allSelected,
  totalCount,
  emailAbleIds,
  badgeSolid,
  type,
  typeId,
  onDownloadToExcel,
  children,
}: KursusDeltagereHandlingerDropdownProps) => {
  const [clear, setClear] = useState(false);
  const [activeModal, setActiveModal] = useState("sendemail");

  return (
    <ModalProvider>
      <DropdownRoot className="c-dropdown-default--actions z-index-lower">
        <HandlingerDropdownTrigger
          type={typeTitle}
          selectedIdsLength={selectedIds.length}
          allSelected={allSelected}
          totalCount={totalCount}
          badgeSolid={badgeSolid}
        />
        <DropdownContent>
          <DropdownItem asChild>
            <ModalTrigger onClick={() => setActiveModal("sendemail")}>
              <DropdownItemIcon>
                <EmailIcon />
              </DropdownItemIcon>
              <span className="d-flex gap-2 align-items-center">
                Send e-mail...
                <div className="badge rounded-pill">{emailAbleIds.length}</div>
              </span>
            </ModalTrigger>
          </DropdownItem>

          <DropdownSeparator />

          <DropdownItem
            disabled={!onDownloadToExcel}
            onClick={onDownloadToExcel}
          >
            <DropdownItemIcon>
              <DownloadListIcon />
            </DropdownItemIcon>
            <span>Hent til Excel</span>
          </DropdownItem>

          {children}
        </DropdownContent>
      </DropdownRoot>
      {activeModal === "sendemail" && (
        <SendEmailModal
          type={type}
          contextData={{
            allSelected,
            selectedIds: emailAbleIds,
            typeId,
            totalCount: emailAbleIds.length,
          }}
          clear={clear}
          setClear={setClear}
        />
      )}
    </ModalProvider>
  );
};

export default KursusDeltagereHandlingerDropdown;
